import React from 'react';
import FocusLayout from '../../components/FocusLayout';
import Redeem from '../../components/Redeem';
import { getPagePresentationKeys } from '../../actions/page';
import { SALES_CHANNELS, DEFAULT_PAGE_TITLE } from '../../constants';
import { getSalesChannelId } from '../../helpers/userStorage';
import { setSalesChannel } from '../../actions/config';
import { showError } from '../../components/Notifications/notificationTypes';

const pageName = 'redeem';

async function action({ store, client }, { voucherCode, ...params }) {
  const useSalesChannel = SALES_CHANNELS.REDEEM;

  // ensure Redeem sales channel sales flows
  const localStorageSalesChannelId = getSalesChannelId();
  const {
    giftcard: { errors },
    intl: { locale, countryCode, currency },
    config: { salesChannelId: stateSalesChannelId },
  } = store.getState();

  // ensure correct sales channel and locale when location changed with history.push
  // if url params and locale differ it should be handled by server: ex. Shop -> Redeem -> Shop
  if (
    useSalesChannel &&
    (useSalesChannel !== stateSalesChannelId ||
      useSalesChannel !== localStorageSalesChannelId)
  ) {
    await store.dispatch(setSalesChannel(useSalesChannel));
  }
  if (
    params &&
    (params.countryCode !== countryCode.toLowerCase() ||
      params.locale !== locale.toLowerCase() ||
      params.currency !== currency.toLowerCase())
  ) {
    document.location.reload();
  }

  const {
    byName: {
      [pageName]: { pageTitle, pageDescription, pageBackgroundImage },
    },
  } = await store.dispatch(getPagePresentationKeys({ pageName }));

  // show error if redirected from verify-owner page
  if (errors) {
    showError({
      errors: errors
        .filter(e => !!(e && e.extensions))
        .map(({ extensions: { code }, message }) => ({
          code: code || 'UNAUTHORIZED_ACCESS', // if no code use error message "contact support" same as for this code
          message,
        })),
      context: 'giftcard',
    });
  }

  return {
    title: pageTitle || DEFAULT_PAGE_TITLE,
    description: pageDescription,
    chunks: ['redeem'],
    component: (
      <FocusLayout
        focusContentBox={false}
        gradient
        footer
        footerBar
        selectCountryMessage
        backgroundImage={pageBackgroundImage}
        centerContent
      >
        <Redeem backLink client={client} voucherCode={voucherCode} />
      </FocusLayout>
    ),
    salesChannelId: useSalesChannel,
  };
}

export default action;
